const findDistanceURL = process.env.REACT_APP_DISTANCE_API;
export function getGoogleTime(transitObj) {
    let fullURL = findDistanceURL + "?startAddress=" + transitObj.start + "&outAddress=" + transitObj.end;
    const promise = new Promise((resolve, reject) => {
        fetch(fullURL, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
                return reject(response);
            }
        ).then( (response)=> {
            try {
                if (response.Success) {
                    return resolve(response.Result);
                } else {
                    return reject(response.Message);
                }
            }
            catch {
                return reject("Error");
            }
      });
    });
    return promise;
}
